import { ModalContent } from '@nile/banyan/src/Utils/style';
import styled from 'styled-components';

const Modal = styled(ModalContent)`
  background: none;
  width: 100%;
  height: ${(props) => (props.isExport ? '100%' : '100vh')};
  .FormContainer {
    padding: 0 !important;
    height: ${(props) => (props.isExport ? '100%' : '100vh')};
  }
  .save-card {
    // margin: 0 !important;
    background: none;
  }
  .Polaris-Card {
    border-radius: 8px !important;
  }
  .reportSection {
    height: ${(props) =>
      props.isViewOnly || props.isExport ? '100%' : 'calc(100vh - 155px)'};
    overflow: ${(props) => (props.disableScroll ? 'auto' : 'scroll')};
    scrollbar-width: ${(props) =>
      props.disableScroll ? 'none' : 'auto'}; /* Firefox */
    -ms-overflow-style: ${(props) =>
      props.disableScroll ? 'none' : 'auto'}; /* IE/Edge */
    &::-webkit-scrollbar {
      display: ${(props) => (props.disableScroll ? 'none' : 'block')};
    }
  }
`;

export { Modal };
